import state from "./state";

// Import models
import { Group } from "@/models/responses.model";

// Helper Functions
function IsJsonString(str: string) {
  try {
    let json = JSON.parse(str);
    return json;
  } catch (e) {
    return false;
  }
}

const getters = {
  getbreadCrumbs() {
    let bcString: any = state.config.breadCrumbs;
    if (bcString !== null) {
      const obj = IsJsonString(bcString);
      return obj;
    }
  },
  getSortedGroups() {
    const groupsData: Array<Group> = state.groups.data.filter(
      (item: Group) => item.sortOrder !== null
    );

    if (groupsData.length) {
      groupsData.sort((a, b) => (a.sortOrder || 0) - (b.sortOrder || 0));
    }

    return groupsData;
  },
  getAllAppliances(){
    const allAppliances: Array<Group> = state.groups.data.filter(
      (item: Group) => item.id === "9"
    );

    let currentApplianceName;

    if(allAppliances.length) {
      
      const allApplianceTags = allAppliances[0].tags;
      const currentRecipeTags: any = state.currentRecipe.tags;
      // @ts-ignore
      const currentApplianceArray = allApplianceTags.filter(({ id: id1 }) => currentRecipeTags.some(({ id: id2 }) => id2 === id1));
      // @ts-ignore
      currentApplianceName = currentApplianceArray[0].name;
    }
    return currentApplianceName;
  },
  getCollections() {
    const collections = getters
      .getSortedGroups()
      .map((group) => group.tags)
      .flat()
      .filter(
        (tag: any) =>
          tag.inspirationName && tag.inspirationImage && tag.inspirationOrder
      )
      .sort((a: any, b: any) => a.inspirationOrder - b.inspirationOrder);
    return collections;
  },
  isLastPage() {
    // @todo Add RootState interface
    // @ts-ignore
    if (state.recipes.meta.perfect_matches !== null) {
      // @todo Add RootState interface
      // @ts-ignore
      return (
        state.searchParams.page >=
        Math.ceil(
          // @todo Add RootState interface
          // @ts-ignore
          state.recipes.meta.perfect_matches / state.searchParams.pagesize
        )
      );
    }

    // @todo Add RootState interface
    // @ts-ignore
    return state.searchParams.page === state.recipes.meta.pages;
  },
  getFirstSlide() {
    return state.slides.data
      .filter(
        (slide: any) =>
          slide.tag !== null && slide.targetUri.includes("recipes")
      )
      .map((slide: any) => {
        const id = slide.targetUri.replace("/cooking/v2/recipes/", "");
        const image = slide.imageUri.replace("?imwidth=1920", "");
        const contentPosition = "bottom-left";
        const headline = slide.title;

        return {
          headline,
          imageRatios: "",
          preline: "",
          inverted: "",
          image,
          contentPosition,
          id,
        };
      });
  },
};

// {
//   name: "Detail",
//   params: {
//     title: slides[0].title,
//     id: slides[0].targetUri.replace("/cooking/v2/recipes/", "")
//   }
// }

export default getters;
